module.exports = __webpack_public_path__ + "img/FR.35750d59.svg";